import type { ComponentType } from 'react';
import StepOne from 'modules/account/create/steps/StepOne';
import StepTwo from 'modules/account/create/steps/StepTwo';
import StepThree from 'modules/account/create/steps/StepThree';

export type StepIndex = 0 | 1 | 2;

export interface StepConfig {
  index: StepIndex;
  labelId: string;
  Component: ComponentType;
}

export type StepConfigs = readonly [StepConfig, StepConfig, StepConfig];

export const ACCOUNT_CREATE_STEPS: StepConfigs = [
  { index: 0, labelId: 'account.detail', Component: StepOne },
  { index: 1, labelId: 'account.userInfo', Component: StepTwo },
  { index: 2, labelId: 'account.roleAssignment', Component: StepThree },
] as const;
